<template>
   <div v-if="user && ratingData">
       <div class="columns">
           <div class="column is-6">
               <h1 class="title is-3 between-center">
                   <span>View User</span>
               </h1>
           </div>
           <div class="column is-6 toolbar-box">
               <div class="field is-grouped is-grouped-right">
                   <p class="control">
                       <router-link :to="{ name: 'users.index' }" class="button is-info" >Back</router-link>
                   </p>
                   <p class="control" v-if="currentUserIsAdmin">
                       <a @click.prevent="handleDeletion(user, 'users.index')" class="button is-danger">Delete</a>
                   </p>
                   <p class="control" v-if="currentUserIsAdmin">
                       <router-link :to="{ name: 'users.edit', params: { slug: user.id } }" class="button is-info"><span class="icon"><i class="icm-new"></i></span><span>Edit</span></router-link>
                   </p>
                 <p class="control" v-if="!currentUserIsAdmin">
                   <router-link :to="{ name: 'users.edit', params: { slug: user.id } }" class="button is-success"><span class="icon"><i class="icm-new"></i></span><span>View More Info</span></router-link>
                 </p>
               </div>
           </div>
       </div>
       <div class="columns is-6">
           <div class="column">
                <div class="card tilebox-one">
                    <div class="card-body">
                        <i class="dripicons-basket float-end text-muted"></i>
                        <h6 class="text-muted text-uppercase mt-0">Selected Period</h6>
                        <div class="columns" style="padding: 0px 8px;margin-top: 7px;">
                            <o-field label="Year">
                                <o-select
                                    v-model="filters.year">
                                    <option v-for="y in years" :key="y" :value="y">{{ y }} </option>
                                </o-select>
                            </o-field>
                            <o-field label="Month">
                                <o-select
                                    v-model="filters.month">
                                    <option v-for="(m,i) in months" :key="m" :value="i+1">{{ m }} </option>
                                </o-select>
                            </o-field>
                        </div>
                    </div>
                </div>
            </div>
            <billing-card :params="paramsCurrent" :params-previous="paramsPrevious" :user="user" v-model="billingData" />
            <non-billable-card :params="paramsCurrent" :user="user" v-model="nonBillableData" />
            <accuracy-card :params="paramsCurrent" :params-previous="paramsPrevious" :user="user" v-model="accuracyData" />
            <timelog-card :params="paramsCurrent" :params-previous="paramsPrevious" :user="user" v-model="timelogData" />
            <ef-rating :rating-data="ratingData" :user="user" v-model="efRating" />
            <potential-bonus :user="user" :ef-rating="efRating" />
       </div>
        <div class="columns is-multiline">
            <div class="column is-12-tablet is-12-desktop is-12-widescreen is-3-fullhd">
                <div class="columns is-multiline">
                    <div class="column is-3-widescreen is-12-fullhd">
                        <info :user-id="userId"/>
                    </div>
                    <div class="column is-9-widescreen is-12-fullhd">
                        
                    </div>
                </div>
            </div>
            <div class="column is-12-tablet is-12-desktop is-12-widescreen is-9-fullhd">
                
                <o-tabs type="is-boxed" @update:modelValue="handleTabChange">
                    <o-tab-item label="Billing">
                        <billing-chart :user-id="userId" :selected-year="filters.year" />
                    </o-tab-item>
                    <o-tab-item label="Proposals">
                        <proposals :user-id="userId" />
                    </o-tab-item>
                    <o-tab-item label="Followed Projects">
                        <followed-projects :user-id="userId" :user="user"/>
                    </o-tab-item>
                    <o-tab-item label="All Projects">
                        <projects :user-id="userId" />
                    </o-tab-item>
                    <o-tab-item label="Hourly Rates">
                        <hourly-rates :user-id="userId" />
                    </o-tab-item>
                    <o-tab-item label="Reviews">
                        <reviews :user="user" :period="currentPeriod" :ef-rating="efRating" />
                    </o-tab-item>
                </o-tabs >
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from '../../mixins/Table'
    import Info from './show/Info.vue'
    import Projects from './show/Projects'
    import Proposals from './show/Proposals'
    import HourlyRates from './show/HourlyRates'
    import FollowedProjects from './show/FollowedProjects'
    import BillingChart from './show/BillingChart'
    import Reviews from './show/Reviews.vue'
    import EfRating from './show/cards/EfRating'
    import PotentialBonus from './show/cards/PotentialBonus'
    import BillingCard from './show/cards/BillingCard'
    import NonBillableCard from './show/cards/NonBillableCard'
    import TimelogCard from './show/cards/TimelogCard'
    import AccuracyCard from "./show/cards/AccuracyCard";

    export default {
        mixins: [Table],

        components: {
            Info,
            Projects,
            Proposals,
            HourlyRates,
            FollowedProjects,
            BillingChart,
            Reviews,
            EfRating,
            PotentialBonus,
            BillingCard,
            NonBillableCard,
            TimelogCard,
            AccuracyCard
            },

        data() {
            return {
                filters: {
                    year: (new Date).getFullYear(),
                    month: +moment().format('MM'),
                    team_id: null,
                    users: [],
                },
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                years: [],
                fetched: false,
                openedTabs: [0],
                billingData: null,
                nonBillableData: null,
                timelogData: null,
                accuracyData: null,
                efRating: 0
            }
        },

        created () {
            for(let i = 2013; i <= (new Date).getFullYear(); i++) {
                this.years.push(i);
            }
            this.fetchUserById(this.$route.params.slug)
                .then(res => {
                    this.fetched = true
                    return res
                })

        },


      methods: {
            ...mapActions({
                fetchUserById: 'fetchUserById',
                removeItem: 'removeUser',

            }),

            handleDeletion (user) {
                if (user.id == this.currentUserId) {
                    return this.$swal.fire({
                        icon: 'danger',
                        text: 'You are trying to delete yourself. Sorry, this action is not allowed'
                    })
                }

                this.confirmCustomDelete(user, 'users.index')
            },

            handleTabChange(index) {
                this.openedTabs.push(index)
            },
            resetFilters() {
                this.filters = {
                    year: (new Date).getFullYear(),
                    month: moment().format('MM'),
                    team_id: null,
                    users: []
                }
            },
        },

        computed: {
            ...mapGetters(['userById', 'currentUserId', 'currentUserIsAdmin']),

            userId () {
                return parseInt(this.$route.params.slug)
            },

            user () {
                return this.userById(this.userId)
            },
            currentPeriod() {
                return moment().year(this.filters.year).month(this.filters.month - 1).date(1)
            },
            previousPeriod() {
                return moment().year(this.filters.year).month(this.filters.month - 1).date(1).subtract('months', 1)
            },
            currentYear() {
                return this.currentPeriod.format('YYYY')
            },
            currentMonth() {
                return this.currentPeriod.format('MM')
            },
            previousYear() {
                return this.previousPeriod.format('YYYY')
            },
            previousMonth() {
                return this.previousPeriod.format('MM')
            },
            paramsCurrent() {
                return { year: this.currentYear, month: this.currentMonth, users: [this.user.id]  }
            },
            paramsPrevious() {
                 return { year: this.previousYear, month: this.previousMonth, users: [this.user.id]  }
            },
            ratingData() {
                return { billingData: this.billingData, nonBillableData: this.nonBillableData, timelogData: this.timelogData, accuracyData: this.accuracyData }
            },
        },

      mounted() {
        this.fetchUserById(this.$store.state.auth.currentUserId)
            .then(response => {
              if (response.data.data.role !== "admin" && parseInt(this.$route.params.slug) !== this.currentUserId){
                this.$router.push("/projects")
              }
            })
      }
    }
</script>
<style>
    .mt-0 {
    margin-top: 0!important;
}

.text-muted {
    --ct-text-opacity: 1;
    color: #98a6ad!important;
}

.badge {
    vertical-align: middle;
}
.bg-alert {
    background-color: #ee4d4d!important;
}

.bg-primary {
    background-color: #77b477!important;
}



.badge {
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: .75em;
    font-weight: 700;
    line-height: 1;
    color: #ffffff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}

.card.tilebox-one {padding: 10px;border-radius: 5px;box-shadow: 0px 0px 2px 1px #0000000f;}

h2.m-b-20 {font-size: 1.875rem;}

small {
  font-size: 1em;
}
</style>